<script setup>
import {ref,onMounted,provide} from 'vue';


// provide('audioPlayer',audioPlayer);

const isMoblie = ()=>{
      var u = navigator.userAgent;
      if (!!u.match(/AppleWebKit.*Mobile.*/) && process.env.NODE_ENV === 'production') {
        // console.log('移动端');
          location.href = ' https://mtkd.xleplay.com/mobile/dist/'
      }
    }

onMounted(()=>{
  isMoblie();

})
</script>

<template>
  <div id="app">

    <div class="main">
      <div class="main-content"> 
            <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.main {
  // width: 100vw;
  height: 100vh;
}

.audio-box{
  // background: url('./assets/images/main/');
}
</style>